import React, { useState } from 'react'
import { change, Field } from 'redux-form'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import LocalizedDatePicker from '../../../../components/LocalizedDatePicker'
import { useTheme } from '@material-ui/core/styles'
import { date } from '../../../../utilties/validators'


const styles = (theme) => ({
	input: {
		color: 'black',
		fontSize: '1rem',
		backgroundColor: theme.palette.secondary.inputHover
	},

	root: {
		color: 'black'
	},
	focused: {
		color: 'black',
		backgroundColor: theme.palette.secondary.inputHover,
		'&$focused': {
			color: 'black',
			backgroundColor: theme.palette.secondary.inputHover
		}
	}
});

const useLabelStyles = makeStyles((theme) => ({
	root: {
		color: 'black',
		backgroundColor: theme.palette.secondary.inputHover
	},
	focused: {
		color: 'white',
		backgroundColor: theme.palette.secondary.inputHover,
		'&$focused': {
			color: 'black',
			backgroundColor: theme.palette.secondary.inputHover
		}
	}
}));

const useInputStyles = makeStyles((theme) => ({
	root: {
		color: 'white',
		position: 'relative',
		fontSize: '16px',
		transition: 'background-color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
		backgroundColor: 'rgba(0, 0, 0, 0.09)',
		'border-top-left-radius': '4px',
		'border-top-right-radius': '4px'
	},
	focused: {
		color: 'white',
		backgroundColor: theme.palette.secondary.inputHover,
		'&$focused': {
			color: 'black',
			backgroundColor: theme.palette.secondary.inputHover
		}
	}
}));

const useHelperStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: '#FFF',
		marginLeft: '0px',
		paddingTop: '6px',
		padding: '8px 0px',
		fontSize: '16px',
		marginTop: '0px'
	}
}));

const renderTextField = ({
	classes,
	label,
	input,
	meta: { touched, invalid, error, form, dispatch },
	inputLabelProps,
	inputProps,
	style,
	fullWidth,
	margin,
	variant,
	type,
	labelStyles,
	inputStyles,
	helperStyles,
	maxLength,
	setHasFocus,
	hasFocus,
	onInnerChange,
	disabled,
	...custom
}) => {
	const handleChange = (date) => {
		onInnerChange(date)
		dispatch(change(form, input.name, date));
	}


	return (
		<div>
			<FormControl
				data-testid="form-date-question-formcontrol"
				style={{
					color: 'black',
					maxWidth: '16rem'
				}}
				error={touched && invalid}
				fullWidth>
				<LocalizedDatePicker
					label={label}
					onDateChange={handleChange}
					error={error}
					defaultDate={input && input.value || null}
					inputProps={{
						style: { color: 'black', paddingTop: '10px' }
					}}
					openToYear={false}
					touched={touched}
					externalHelperStyles={helperStyles}
					disabled={disabled}
				/>
			</FormControl>
		</div>
	)
}

const FormDateField = ({
	classes,
	label,
	name,
	inputLabelProps,
	inputProps,
	style,
	fullWidth,
	margin,
	variant,
	type,
	validators,
	disabled,
	onValueChange,
	maxLength = 10
}) => {
	var labelStyles = useLabelStyles()
	var inputStyles = useInputStyles()
	var helperStyles = useHelperStyles()
	const [hasFocus, setHasFocus] = useState(false)

	const handleInnerChange = (value) => {
		onValueChange(value)
	}

	const currentValidators = [
		...validators,
		date
	]

	return (
		<Field
			name={name}
			hasFocus={hasFocus}
			setHasFocus={setHasFocus}
			component={renderTextField}
			label={label}
			inputLabelProps={inputLabelProps}
			inputProps={inputProps}
			style={style}
			fullWidth={fullWidth}
			margin={margin}
			variant={variant}
			type={type}
			validate={currentValidators}
			maxLength={maxLength}
			classes={classes}
			labelStyles={labelStyles}
			inputStyles={inputStyles}
			helperStyles={helperStyles}
			onInnerChange={handleInnerChange}
			disabled={disabled}
		/>
	)
}

export default withStyles(styles)(FormDateField)
